import bindAll from 'lodash.bindall';
import PropTypes from 'prop-types';
import React from 'react';
import {injectIntl, intlShape, defineMessages} from 'react-intl';
import VM from 'scratch-vm';

import spriteLibraryContent from '../lib/libraries/sprites.json';
import randomizeSpritePosition from '../lib/randomize-sprite-position';
import spriteTags from '../lib/libraries/sprite-tags';

import LibraryComponent from '../components/library/library.jsx';

const messages = defineMessages({
    libraryTitle: {
        defaultMessage: 'Choose a Sprite',
        description: 'Heading for the sprite library',
        id: 'gui.spriteLibrary.chooseASprite'
    }
});

class SpriteLibrary extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, [
            'handleItemSelect'
        ]);
        this.state = {
            customSprites: []
        };
    }

    componentDidMount () {
        // Fetch custom sprites uploaded by admin and merge with static library
        fetch('/api/sprites', {
            credentials: 'same-origin',
            headers: {Accept: 'application/json'}
        })
            .then(res => {
                if (res.ok) return res.json();
                return [];
            })
            .catch(() => [])
            .then(custom => {
                // Mark custom sprites so they use local assetHost for thumbnails
                const marked = (custom || []).map(sprite => ({
                    ...sprite,
                    _isCustom: true
                }));
                this.setState({customSprites: marked});
            });
    }

    handleItemSelect (item) {
        // Randomize position of library sprite
        randomizeSpritePosition(item);
        this.props.vm.addSprite(JSON.stringify(item)).then(() => {
            this.props.onActivateBlocksTab();
        });
    }

    render () {
        const allSprites = [...this.state.customSprites, ...spriteLibraryContent];
        return (
            <LibraryComponent
                assetHost={typeof window !== 'undefined' ? window.location.origin : ''}
                data={allSprites}
                id="spriteLibrary"
                tags={spriteTags}
                title={this.props.intl.formatMessage(messages.libraryTitle)}
                onItemSelected={this.handleItemSelect}
                onRequestClose={this.props.onRequestClose}
            />
        );
    }
}

SpriteLibrary.propTypes = {
    intl: intlShape.isRequired,
    onActivateBlocksTab: PropTypes.func.isRequired,
    onRequestClose: PropTypes.func,
    vm: PropTypes.instanceOf(VM).isRequired
};

export default injectIntl(SpriteLibrary);
